import { useState } from "react";
import EmployeeModal from "./EmployeesMain";

function EmployeeNewMain() {
  const [isOpen, setIsOpen] = useState(false);


  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="min-h-screen w-full flex items-center justify-center p-4">
          <button
            onClick={() => setIsOpen(true)}
            className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Open Modal
          </button>
          <EmployeeModal isOpen={isOpen} onClose={handleClose} />
        </div>
      </div>
    </div>
  );
}

export default EmployeeNewMain;
